var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "results__list" }, [
    _vm.isTab2
      ? _c("div", [
          _vm.supplierCount
            ? _c(
                "div",
                [
                  _vm.showResultsCountText
                    ? _c("div", [
                        _vm.supplierResultsShowing < _vm.suppliers.length
                          ? _c("div", [
                              _c("p", { staticClass: "p-large" }, [
                                _vm._v("\n            Showing "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.supplierResultsShowing)),
                                ]),
                                _vm._v(" out of "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.suppliers.length)),
                                ]),
                                _vm._v(" results\n          "),
                              ]),
                            ])
                          : _c("div", [
                              _c("p", { staticClass: "p-large" }, [
                                _vm._v("\n            Showing "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.suppliers.length)),
                                ]),
                                _vm._v(" out of "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.suppliers.length)),
                                ]),
                                _vm._v(" results\n          "),
                              ]),
                            ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.suppliers, function (supplier, index) {
                    return _c("div", { key: supplier.vendorID }, [
                      index < _vm.supplierResultsShowing
                        ? _c(
                            "div",
                            [
                              _c("ResultCard", {
                                attrs: {
                                  supplierId: supplier.vendorID,
                                  isTab2: _vm.isTab2,
                                  supplierRegions: supplier.vendorRegions,
                                  supplierEmailAddress:
                                    supplier.vendorEmailAddress,
                                  supplierName: supplier.vendorName,
                                  supplierPage: supplier.vendorProfile,
                                  supplierPhoneNumber:
                                    supplier.vendorPhoneNumber,
                                  supplierURLPhoneNumber:
                                    supplier.vendorURLPhoneNumber,
                                  supplierWebsite: supplier.vendorWebsite,
                                  supplierWebsiteText:
                                    supplier.vendorWebsiteText,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.showResultsCountText
                    ? _c("div", [
                        _vm.supplierResultsShowing < _vm.suppliers.length
                          ? _c("div", [
                              _c("p", { staticClass: "p-large" }, [
                                _vm._v("\n            Showing "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.supplierResultsShowing)),
                                ]),
                                _vm._v(" out of "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.suppliers.length)),
                                ]),
                                _vm._v(" results\n          "),
                              ]),
                            ])
                          : _c("div", [
                              _c("p", { staticClass: "p-large" }, [
                                _vm._v("\n            Showing "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.suppliers.length)),
                                ]),
                                _vm._v(" out of "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.suppliers.length)),
                                ]),
                                _vm._v(" results\n          "),
                              ]),
                            ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.supplierResultsShowing < _vm.suppliers.length ||
                  _vm.suppliers.length > _vm.supplierResultsShowing
                    ? _c("div", { staticClass: "button__wrapper-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button button-tertiary",
                            attrs: { "aria-label": "Load more results" },
                            on: {
                              click: function ($event) {
                                _vm.supplierResultsShowing += 20
                              },
                            },
                          },
                          [_vm._v("\n          See more\n        ")]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _c("div", [
                _vm.showNoResultsText
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "results__no-results-wrapper" },
                        [
                          _c("h6", {
                            domProps: { innerHTML: _vm._s(_vm.noResultsText) },
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
        ])
      : _c("div", [
          _vm.providerCount
            ? _c(
                "div",
                [
                  _vm.showResultsCountText
                    ? _c("div", [
                        _vm.providerResultsShowing < _vm.providers.length
                          ? _c("div", [
                              _c("p", { staticClass: "p-large" }, [
                                _vm._v(" Showing "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.providerResultsShowing)),
                                ]),
                                _vm._v(" out of "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.providers.length)),
                                ]),
                                _vm._v(" results"),
                              ]),
                            ])
                          : _c("div", [
                              _c("p", { staticClass: "p-large" }, [
                                _vm._v(" Showing "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.providers.length)),
                                ]),
                                _vm._v(" out of "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.providers.length)),
                                ]),
                                _vm._v(" results"),
                              ]),
                            ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.providers, function (provider, index) {
                    return _c("div", { key: provider.ID }, [
                      index < _vm.providerResultsShowing
                        ? _c(
                            "div",
                            [
                              _c("ResultCard", {
                                attrs: {
                                  culturalExperience:
                                    provider.culturalExperience,
                                  providerId: provider.providerAccIdentifier,
                                  isTab2: _vm.isTab2,
                                  firstName: provider.firstName,
                                  gender: provider.genderCode,
                                  languages: provider.languages,
                                  regions: provider.regions,
                                  surname: provider.surname,
                                  therapistExperience:
                                    provider.therapistExperience,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.showResultsCountText
                    ? _c("div", [
                        _vm.providerResultsShowing < _vm.providers.length
                          ? _c("div", [
                              _c("p", { staticClass: "p-large" }, [
                                _vm._v(" Showing "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.providerResultsShowing)),
                                ]),
                                _vm._v(" out of "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.providers.length)),
                                ]),
                                _vm._v(" results"),
                              ]),
                            ])
                          : _c("div", [
                              _c("p", { staticClass: "p-large" }, [
                                _vm._v(" Showing "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.providers.length)),
                                ]),
                                _vm._v(" out of "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.providers.length)),
                                ]),
                                _vm._v(" results"),
                              ]),
                            ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.providerResultsShowing < _vm.providers.length ||
                  _vm.providers.length > _vm.providerResultsShowing
                    ? _c("div", { staticClass: "button__wrapper-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button button-tertiary",
                            attrs: { "aria-label": "Load more results" },
                            on: {
                              click: function ($event) {
                                _vm.providerResultsShowing += 20
                              },
                            },
                          },
                          [_vm._v("\n          See more\n        ")]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _c("div", [
                _vm.showNoResultsText
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "results__no-results-wrapper" },
                        [
                          _c("h6", {
                            domProps: { innerHTML: _vm._s(_vm.noResultsText) },
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }